import { defineMessages } from "react-intl";

const baseId = "t.ui.text.detail.";

export default defineMessages({
  moreInfo: {
    id: baseId + "moreInfo",
    defaultMessage: "More Info",
  },
});
